import React from 'react';
import PropTypes from 'prop-types';

import { Grid, makeStyles } from '@material-ui/core';

import DropdownAutocomplete from 'components/DropdownAutocomplete';
import { ThemeButton } from 'components/shared';

const useStyles = makeStyles({});

const BenchmarkSelector = ({ index, selected, options, onSelected, onAdvancedButtonClick }) => {
  const classes = useStyles();

  const handleSelected = item => {
    const benchmark = options.find(o => o.value === item.value);
    onSelected(
      {
        name: benchmark.label,
        benchmarkId: benchmark.value
      },
      index
    );
  };

  const handleRemove = benchmarkId => {
    onSelected({
      name: null,
      benchmarkId: +benchmarkId
    });
  };

  return (
    <Grid item container direction="row" align="center" justify="space-between" spacing={1}>
      <Grid item xs={8} className={classes.benchmarkField}>
        <DropdownAutocomplete
          name={selected}
          selected={selected}
          options={options}
          onSelect={handleSelected}
          minWidth="220px"
          listBoxHeight="360px"
          type="seriesType"
          onRemove={handleRemove}
        />
      </Grid>
      <Grid item xs={3}>
        <ThemeButton themeColor="accent" size="small" onClick={() => onAdvancedButtonClick(index)}>
          Advanced
        </ThemeButton>
      </Grid>
    </Grid>
  );
};

BenchmarkSelector.propTypes = {
  index: PropTypes.number.isRequired,
  selected: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number
    })
  ),
  onSelected: PropTypes.func.isRequired,
  onAdvancedButtonClick: PropTypes.func.isRequired
};

BenchmarkSelector.defaultProps = {
  selected: null,
  options: []
};

export default BenchmarkSelector;
